import { render, staticRenderFns } from "./SaleReturnProductsForm2.vue?vue&type=template&id=70eeb942&scoped=true"
import script from "./SaleReturnProductsForm2.vue?vue&type=script&lang=js"
export * from "./SaleReturnProductsForm2.vue?vue&type=script&lang=js"
import style0 from "./SaleReturnProductsForm2.vue?vue&type=style&index=0&id=70eeb942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eeb942",
  null
  
)

export default component.exports